export default __webpack_public_path__ + "static/media/save-filed.dc5ccbda.svg";